// The server refuses a save that would leave a company without an enabled
// Master and answers 400 `{ code: "LAST_MASTER" }`.
export function isLastMasterError(error: any): boolean {
  return error?.response?.data?.code === "LAST_MASTER";
}
